const capturesMap = {
  'cases': 'Кейсы наших клиентов — как фидбек улучшает продукты',
  'clients': 'Нам доверяют 90+ ведущих компаний в России и мире',
}
const capture = document.querySelector(`h1.capture`);
const cases = [...document.querySelector('.content .cases').children];
const filtersSelects = [...document.querySelectorAll('.filtersWrapper .filter .select .currentValue')];
const emptyBlock = document.querySelector('.empty');
const tabs = [...document.querySelectorAll('.casesClients [data-tab]')];
const hash = location.hash.slice(1);
const activeTab = (!hash || hash === 'form-demo') ? 'cases' : hash;
const queryParams = new URLSearchParams(location.search);
const activePageNodes = [...document.querySelectorAll(`[data-tab="${activeTab}"]`)];
const allFilterOptionsList = [...document.querySelectorAll('.selectList li')];
const resetButton = document.querySelector('.resetButton');
const tags = [...document.querySelectorAll('.tags .tag')];
const YM_ID = 49633516;
const sectionName = window.location.href.includes('https://uxfeedback.ru') ? 'cases' : 'test_cases';
let openedFilter = null;
const filterTypes = ['format', 'product', 'sphere'];
const filter = {
  format: queryParams.get('format')?.split(',') || ['all'],
  product: queryParams.get('product')?.split(',') || ['all'],
  sphere: queryParams.get('sphere')?.split(',') || ['all'],
};

if (activePageNodes.length > 0) {
  capture.innerHTML = capturesMap[activeTab];

  [...document.querySelectorAll(`.active[data-tab]`)].map((node) => {
    node.classList.remove('active');
  })
  activePageNodes.map((node) => {
    node.classList.add('active');
  });
}

const filterCases = () => {
  const hiddenCases = cases.filter((item) => !Object.values(filter).every((filterValues) => filterValues.some((value) => item.dataset.types.includes(value))));

  cases.forEach((item) => item.classList.remove('hide'));
  hiddenCases.forEach((item) => item.classList.add('hide'));

  if ([...new Set(Object.values(filter).reduce((acc, filterValues) => [...acc, ...filterValues], []))].length > 1) {
    resetButton.classList.add('active');
  } else {
    resetButton.classList.remove('active');
  }

  if (hiddenCases.length === cases.length) {
    emptyBlock.classList.add('show');
  } else {
    emptyBlock.classList.remove('show');
  }

  const url = new URL(window.location.href);

  url.search = '';
  filterTypes.forEach((filterType) => {
    url.searchParams.append(filterType, filter[filterType].join(','));
  });
  window.history.pushState({}, '', url);
};

const showFieldList = (element, text) => {
  document.querySelector('.field.active').classList.remove('active');
  element.classList.add('active');
  document.querySelector('.field-filter').classList.remove('active');
  document.querySelector('.current-field span').textContent = text;
}

const changeFilterText = (filterType) => {
  document.querySelector(`.filter.${filterType} .currentValue .value`).textContent = filter[filterType]
    .map((value) => document.querySelector(`[data-${filterType}=${value}] .name`).textContent)
    .join(', ');
}

const selectAll = (filterType) => {
  filter[filterType] = ['all'];
  allFilterOptionsList.filter((item) => item.classList.contains(filterType)).forEach((item) => item.classList.remove('active'));
  document.querySelector(`[data-${filterType}=all]`).classList.add('active');
  changeFilterText(filterType);
  filterCases();
}

const getFilterType = (dataset) => {
  if (dataset.format) {
    return 'format';
  }

  if (dataset.product) {
    return 'product';
  }

  return 'sphere';
};

const changeFilterValues = (filterType, currentTarget) => {
  const { dataset } = currentTarget;

  return currentTarget.classList.contains('active')
    ? filter[filterType].filter((filterItem) => filterItem !== dataset[filterType])
    : [...filter[filterType].filter((value) => value !== 'all'), dataset[filterType]];
}

const setFilter = ({ currentTarget }) => {
  const { dataset } = currentTarget;
  const filterType = getFilterType(dataset);
  const filterValues = changeFilterValues(filterType, currentTarget);

  if (filterValues.length === 0 || dataset[filterType] === 'all') {
    selectAll(filterType);
    window.ym?.(YM_ID, 'reachGoal', 'filters_cases_click', { [sectionName]: { article_filters: filter } });

    return;
  }

  filter[filterType] = filterValues;
  currentTarget.classList.toggle('active');
  currentTarget.parentElement.querySelector(`[data-${filterType}=all]`).classList.remove('active');
  changeFilterText(filterType);
  filterCases();
  window.ym?.(YM_ID, 'reachGoal', 'filters_cases_click', { [sectionName]: { article_filters: filter } });
};

const resetFilter = (type) => () => { 
  filterTypes.forEach((filterType) => {
    filter[filterType] = ['all'];
    selectAll(filterType);
  })

  if (type) {
    window.ym?.(YM_ID, 'reachGoal', 'filters_cases_click', { [sectionName]: { article_filters: { clear_all: type } } });
  }
}

const highlightFiltersItems = (filterType) => {
  document.querySelector(`[data-${filterType}=all]`).classList.remove('active');
  allFilterOptionsList
    .filter((item) => item.classList.contains(filterType) && filter[filterType].includes(item.dataset[filterType]))
    .forEach((item) => item.classList.add('active'));
}

tabs.map((tab) => {
  tab.addEventListener('click', (e) => {
    const { tab } = e.target.dataset;

    capture.innerHTML = capturesMap[tab];

    [...document.querySelectorAll(`.active[data-tab]:not([data-tab=${tab}])`)].map((node) => {

      node.classList.remove('active');
    });
    [...document.querySelectorAll(`[data-tab=${tab}]`)].map((node) => {
      node.classList.add('active');
    });
  })
})

filtersSelects.map((filterElement) => {
  filterElement.addEventListener('click', ({ currentTarget }) => {
    currentTarget.parentElement.classList.toggle('active');
    openedFilter = currentTarget.parentElement;
  });
});

document.addEventListener('click', ({ target }) => {
  if (openedFilter && !openedFilter.contains(target)) {
    openedFilter.classList.remove('active');
    openedFilter = null;
  }
}, { capture: true });

emptyBlock
  .querySelector('.reset')
  .addEventListener('click', resetFilter('page'));

resetButton.addEventListener('click', resetFilter('filters'));

allFilterOptionsList.forEach((optionElement) => {
  optionElement.addEventListener('click', setFilter)
});

filterTypes.forEach((filterType) => {
  highlightFiltersItems(filterType)
  changeFilterText(filterType);
  filterCases();
});

tags.forEach((tag) => tag.addEventListener('click', ({ currentTarget }) => {
  const { dataset } = currentTarget;
  const filterType = getFilterType(dataset);

  resetFilter()();
  filter[filterType] = [dataset[filterType]];
  highlightFiltersItems(filterType)
  changeFilterText(filterType);
  filterCases();
  document.querySelector('.filtersWrapper').scrollIntoView({ block: 'end', behavior: 'smooth' });
}))
